import { ReactComponent as AddOutline } from '@basqet-dashboard/common/assets/icons/add-outline.svg';
import { Button } from '@basqet-dashboard/common/components';
import { useNavigateTo } from '@basqet-dashboard/common/utils';
import React, { useState } from 'react';

import { PayoutRecentTransactions } from '..';
import { TwoFactorAuth } from '../2fa';
import { ConfirmTransaction, ProcessPayout, SelectAccount } from '.';

const SingleTransferPage = () => {
  const { navigateTo } = useNavigateTo();

  const [currentStage, setCurrentStage] = useState('SELECT_ACCOUNT');
  const [transactionInfo, setTransactionInfo] = useState({
    currency_id: '',
    recipient: '',
    address: ''
  });

  const CurrentPayoutView = stages[currentStage];

  return (
    <section className="payout">
      <CurrentPayoutView
        setCurrentStage={setCurrentStage}
        transactionInfo={transactionInfo}
        setTransactionInfo={setTransactionInfo}
      />
      <div>
        <PayoutRecentTransactions />
        {currentStage === 'SELECT_ACCOUNT' && (
          <Button
            size="large"
            variant="dashed"
            isFull
            onClick={() => navigateTo('/payouts/bulk-transfer')}>
            <AddOutline />
            Bulk Transfer
          </Button>
        )}
      </div>
    </section>
  );
};

const stages = {
  SELECT_ACCOUNT: SelectAccount,
  CONFIRM_TRANSACTION: ConfirmTransaction,
  TWOFA_AUTHENTICATION: TwoFactorAuth,
  PROCESS_PAYOUT: ProcessPayout
};

export { SingleTransferPage };
